import React from 'react';

const Button = ({ text, action }) => {
  return (
    <div className="button" onClick={action}>
      <button>{text}</button>
    </div>
  );
};

export default Button;
